import {Box, ListItemButton, Stack, Typography} from "@mui/material";
import {DescriptionRounded, DevicesRounded, DriveFileMoveRounded, FolderRounded, PointOfSaleRounded, PreviewRounded, ReceiptRounded, RecentActorsRounded, SettingsRounded, UploadFileRounded} from "@mui/icons-material";
import {Link, useLocation} from "react-router-dom";
import { PropTypes } from "prop-types";

const Navigation = ({onItemClick}) => {

    const navItems = [
        {
            id: 1,
            title: "درایو",
            icon: <FolderRounded/>,
            href: "/drive",
        },
        {
            id: 2,
            title: "دفترچه آدرس",
            icon: <RecentActorsRounded/>,
            href: "/drive/my-contacts",
        },
        {
            id: 3,
            title: "فایل های ارسالی",
            icon: <UploadFileRounded/>,
            href: "/drive/my-shares",
        },
        {
            id: 4,
            title: "فایل های دریافتی",
            icon: <DescriptionRounded/>,
            href: "/drive/my-receives",
        },
        {
            id: 5,
            title: "درخواست ارسال",
            icon: <DriveFileMoveRounded/>,
            href: "/drive/request-share",
        },
        {
            id: 6,
            title: "مشاهده کد اشتراک گذاری",
            icon: <PreviewRounded/>,
            href: "/drive/see-share",
        },
        {
            id: 7,
            title: "بسته ها‌ (خرید بسته)",
            icon: <ReceiptRounded/>,
            href: "/drive/plans",
        },
        {
            id: 7,
            title: "تراکنش ها",
            icon: <PointOfSaleRounded/>,
            href: "/drive/transactions",
        },
        {
            id: 9,
            title: "دستگاه های متصل",
            icon: <DevicesRounded/>,
            href: "/drive/connected-devices",
        },
        {
            id: 10,
            title: "تنظیمات حساب",
            icon: <SettingsRounded/>,
            href: "/drive/settings",
        },
    ];

    return (
        <Stack mt={3} p={0} component="ul" spacing={1.5}>
            {navItems.map((i, index) => (
                <NavItem onClick={onItemClick} key={index} title={i.title} icon={i.icon} href={i.href}/>
            ))}
        </Stack>
    )
}
export default Navigation;

const NavItem = (props) => {

    const {title, icon, href, ...restProps} = props
    const {pathname} = useLocation();

    return (
        <ListItemButton
            className={ pathname === href ? "Mui-active" : '' }
            sx={{ p: 0, borderRadius: 1, "&.Mui-active": {color: theme => ({xs: theme.palette.primary.main, lg: "inherit"}), background: theme => theme.palette.background.paper+"5e"} }} {...restProps}>
            <Box component={Link} to={href} sx={{ p: 1.5, width: 1, height: 1, display: "flex", alignItems: "center" }}>
                {icon}
                <Typography ml={1} fontSize={{ xs: ".825rem", lg: ".8rem", xl: ".9rem" }} whiteSpace="nowrap">{title}</Typography>
            </Box>
        </ListItemButton>
    )
};
NavItem.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    href: PropTypes.string,
}